import PropTypes from 'prop-types';
import React from 'react';
import { Button, Col, Modal, Row } from 'react-bootstrap';
import {
  compose,
  defaultProps,
  lifecycle,
  setPropTypes,
  withHandlers,
  withStateHandlers
} from 'recompose';
import Loading from '../pages/loading';
import { TextAreaFormField } from './';
import ToggleBox from './toggle-box';
import { FiCheck } from 'react-icons/fi';

const defaultConfirmLabel = 'OK';

const ConfirmationModal = ({
  cancel,
  cancelLabel,
  actions,
  headingText,
  message,
  show,
  reason,
  isLoading,
  reasonText,
  setReason,
  validationMessage,
  validate,
  className,
  checkboxStates,
  toggleCheckbox
}) => {
  return (
    <Modal className={className} show={show} onHide={cancel}>
      <Modal.Header>
        <Modal.Title componentClass='h2' className='text-center'>
          {headingText}
        </Modal.Title>
      </Modal.Header>

      <Modal.Body className='text-center'>{message}</Modal.Body>

      <Modal.Body className='text-center confirmation-body'>
        {reason ? (
          <form>
            <TextAreaFormField
              {...{
                id: 'reason',
                onChange: setReason,
                value: reasonText,
                validation: validationMessage
              }}
            />
          </form>
        ) : null}
      </Modal.Body>

      <Modal.Footer className='text-center confirmation-footer'>
        {actions.map(
          (
            {
              actionLabel,
              onConfirmAction,
              actionClass,
              hideActionButton,
              checkBoxText,
              bsStyle
            },
            i
          ) =>
            hideActionButton !== true ? (
              <div key={`checkbox-${i}`}>
                {checkBoxText ? (
                  <Row onClick={() => toggleCheckbox(i)}>
                    <Col xs={12}>
                      <div
                        style={{
                          display: 'flex',
                          gap: '12px',
                          alignItems: 'center',
                          cursor: 'pointer'
                        }}
                      >
                        <span id='checkbox'>
                          <ToggleBox
                            small
                            value={checkboxStates[i]}
                            checked={checkboxStates[i]}
                            label={checkboxStates[i] ? <FiCheck /> : null}
                          />
                        </span>
                        <small style={{ textAlign: 'left' }}>
                          {checkBoxText}
                        </small>
                      </div>
                    </Col>
                  </Row>
                ) : null}
                <Row key={`action-button-${i}`}>
                  <Col xs={12}>
                    <Button
                      disabled={checkboxStates[i] === false}
                      {...(bsStyle ? { bsStyle } : {})}
                      className={actionClass}
                      onClick={(e) => {
                        e.preventDefault();
                        e.stopPropagation();
                        validate(onConfirmAction);
                      }}
                    >
                      {isLoading ? (
                        <Loading />
                      ) : (
                        actionLabel || defaultConfirmLabel
                      )}
                    </Button>
                  </Col>
                </Row>
              </div>
            ) : null
        )}

        <Row>
          <Col xs={12}>
            <Button bsStyle='plain' onClick={cancel}>
              {cancelLabel}
            </Button>
          </Col>
        </Row>
      </Modal.Footer>
    </Modal>
  );
};

export default compose(
  setPropTypes({
    show: PropTypes.bool,
    cancel: PropTypes.func.isRequired,
    actions: PropTypes.arrayOf(
      PropTypes.shape({
        onConfirmAction: PropTypes.func.isRequired,
        actionLabel: PropTypes.string,
        actionClass: PropTypes.string,
        hideActionButton: PropTypes.bool,
        checkBoxText: PropTypes.string,
        bsStyle: PropTypes.string
      })
    ),
    message: PropTypes.element.isRequired,
    headingText: PropTypes.element.isRequired
  }),
  defaultProps({
    cancelLabel: 'Cancel',
    show: false,
    actions: []
  }),
  withStateHandlers(
    (props) => ({
      reasonText: '',
      validationMessage: '',
      checkboxStates: props.actions.reduce(
        (acc, { checkBoxText }, idx) => ({
          ...acc,
          [idx]: typeof checkBoxText === 'string' ? false : undefined
        }),
        {}
      )
    }),
    {
      setReason: () => (e) => ({ reasonText: e.target.value }),
      setValidationMessage: () => (validationMessage) => ({
        validationMessage
      }),
      toggleCheckbox:
        ({ checkboxStates }) =>
        (key) => ({
          checkboxStates: { ...checkboxStates, [key]: !checkboxStates[key] }
        })
    }
  ),

  withHandlers({
    validate:
      ({ reason, reasonText, setValidationMessage }) =>
      (onConfirmAction) => {
        if (!reason || reasonText !== '') {
          onConfirmAction(reasonText);
        } else {
          setValidationMessage('Reason is required');
        }
      }
  }),
  lifecycle({
    componentDidMount() {
      const { componentDidMountAction } = this.props;
      if (componentDidMountAction !== undefined) {
        componentDidMountAction();
      }
    }
  })
)(ConfirmationModal);



// WEBPACK FOOTER //
// ./src/containers/components/confirmation-modal.js